import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AccountFeatureState } from './account.reducers';

export const featuresAccountSelector = createFeatureSelector<AccountFeatureState>('featureAccount');

export const selectAccountFeaturesLoaded = createSelector(featuresAccountSelector, state => state.accountFeatures !== null);
